// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:21:33

export default {
  "id": "tower-defenders",
  "slug": "tower-defenders",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d2194f2a265b4ecc9290f961102788db-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d2194f2a265b4ecc9290f961102788db/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Tower Defenders",
      "description": "Fight the undead viking warriors and upgrade your defenses. Use the rewards you get for victories to your advantage. Hold out for as long as you can!\n",
      "instructions": "Upgrade your defense towers and gain coins and gems for defeating enemies. Pick out of three cards every two levels and choose which power-ups will help you best. Last as long as you can in an infinite gameplay.\n",
      "genres": [
        "Strategy"
      ],
      "tags": [
        "clicker",
        "defence",
        "tower"
      ]
    },
    "zh-CN": {
      "title": "塔防者",
      "description": "与不死维京战士战斗并升级你的防御。利用胜利获得的奖励，坚守阵地，尽可能久！",
      "instructions": "升级你的防御塔，击败敌人以获得金币和宝石。每过两个等级，从三张卡牌中选择一张，并选择最适合你的升级道具。在无限游戏模式中尽可能久地存活。",
      "genres": [
        "策略"
      ],
      "tags": [
        "点击器",
        "防御",
        "塔"
      ]
    },
    "zh-TW": {
      "title": "塔防者",
      "description": "與不死维京戰士作戰並升級你的防禦。利用你從勝利中獲得的獎勵。堅持最久！",
      "instructions": "升級你的防禦塔並通過擊敗敵人獲得金幣和 gems。每兩個等級選擇三張卡牌中的一張，並選擇最適合你的加強道具。在無限遊戲中盡可能地延長生存時間。",
      "genres": [
        "策略"
      ],
      "tags": [
        "點擊器",
        "防禦",
        "塔"
      ]
    },
    "zh-HK": {
      "title": "塔防者",
      "description": "與不死維京戰士作戰並升級你的防禦。利用勝利所獲得的獎勵來取得優勢。堅持至最後！",
      "instructions": "升級你的防禦塔並透過擊敗敵人獲得金幣和珍珠。每兩個等級選擇三張卡牌，並選擇最適合你的強化功能。在無限遊戲中盡可能地生存最久。",
      "genres": [
        "策略"
      ],
      "tags": [
        "點擊器",
        "防禦",
        "塔樓"
      ]
    },
    "ja": {
      "title": "タワー・ディフェンダーズ",
      "description": "不死者のヴァイキング戦士と戦い、防衛を強化しよう。勝利で得た報酬を使って有利に立ち返れ。できるだけ長く耐え抜こう！",
      "instructions": "防御塔をアップグレードし、敵を倒してコインと宝石を獲得せよ。2レベルごとに3枚のカードから選び、最も役立つパワーアップを選ぶ。無限のゲームプレイで最も長く生き残れ。",
      "genres": [
        "戦略"
      ],
      "tags": [
        "クリッカーゲーム",
        "防衛",
        "タワー"
      ]
    },
    "ko": {
      "title": "타워 디펜더스",
      "description": "죽은 영웅 비잉 전사들과 싸우고 방어력을 업그레이드하세요. 승리로 얻은 보상을 유리하게 활용하세요. 얼마나 오래 지낼 수 있을지 보세요!",
      "instructions": "의식을 강화하고 적을 물리치며 동전과 보석을 얻으세요. 매 두 레벨마다 세 장의 카드를 골라最适合하는 파워업을 선택하세요. 무한 게임에서 가장 오래 지낼 수 있도록 노력하세요.",
      "genres": [
        "전략"
      ],
      "tags": [
        "클릭러",
        "방어",
        "타워"
      ]
    },
    "fr": {
      "title": "Défenseurs de Tour",
      "description": "Combatez les guerriers vikings des morts-vivants et améliorez vos défenses. Utilisez les récompenses obtenues pour vos victoires à votre avantage. Tenez bon le plus longtemps possible !",
      "instructions": "Améliorez vos tours de défense et gagnez des pièces et des gemmes en vainquant les ennemis. Choisissez parmi trois cartes tous les deux niveaux et sélectionnez les améliorations qui vous seront les plus utiles. Durez le plus longtemps possible dans un gameplay infini.",
      "genres": [
        "Stratégie"
      ],
      "tags": [
        "cliqueur",
        "défense",
        "tour"
      ]
    }
  }
};
